<woo-modal-layout size="medium" (close)="close()">
    <h3 header>Duplicera kampanj</h3>
    <p>Skapar en ny kampanj baserad på en tidigare.</p>
    @if(showSelectInput()) {
      <div class="dropdown-container">
        <woo-dropdown
        class="dropdown-container"
        [items]="customers()"
        [(ngModel)]="selectedCustomer"
        (ngModelChange)="selectedCustomer.set($event)"
        bindLabel="name"
        inputId="customer-search"
        labelText="Kund"
        [searchAttributes]="['name', 'nickname']"
        notFoundText="Inga kunder hittades."
        ></woo-dropdown>
      </div>
    }
    <dot-loader [visibility]="loading()" [large]="false" description=""></dot-loader>
    @if (!loading()) {
      @if(availableCampaigns() && selectedCustomer() !== null) {
        <div class="dropdown-container">
          <woo-dropdown
            [items]="availableCampaigns()"
            [(ngModel)]="selectedCampaign"
            (ngModelChange)="selectedCampaign.set($event)"
            bindLabel="name"
            inputId="campaign-search"
            labelText="Kampanj"
            [searchAttributes]="['name']"
            notFoundText="Inga kampanjer hittades."
          ></woo-dropdown>
        </div>
      }
    }
    @if(selectedCustomer() && availableCampaigns().length === 0 && !loading()) {
      <p class="text--medium"><span class="icon-warning text--info"></span> Den valda kunden har inga tidigare bokade kampanjer</p>
      <button class="button primary-1 button-width lg" (click)="submit.emit()">Skapa en helt ny kampanj</button>
    }
    @if (selectedCampaign && availableCampaigns().length) {
      <button type="button" class="button primary-1 button-width sm" (click)="submit.emit(selectedCampaign())">Duplicera kampanj</button>
    }
</woo-modal-layout>